import i18n from 'i18n'
import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
]

const EN_KEY = { '1': 'common:actions.yes', '0': 'common:actions.no' }

export default function SelectEnabled({...props}) {
    const myProps = {
        placeholder: i18n.t('common:filters.enabledQuestion'),
        firstSelect: true, 
        isClearable: true, 
        options: OPTIONS,
        formatOptionLabel: opt => i18n.t(EN_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        icon: {icon: 'check'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}